export const routerInitialPath = '/';

export const routerMainPageName = 'main';
